import { render, staticRenderFns } from "./ShopChatEditComponent.vue?vue&type=template&id=14ceab25&scoped=true"
import script from "./ShopChatEditComponent.vue?vue&type=script&lang=js"
export * from "./ShopChatEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopChatEditComponent.vue?vue&type=style&index=0&id=14ceab25&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ceab25",
  null
  
)

export default component.exports